import {
    Backdrop,
    Box,
    Button,
    CardContent,
    Fade,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    Modal,
    Select,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import {
    ACLASSE_TIPO_VEIC_AQUATICO,
    ACLASSE_TIPO_VEIC_AUTOMOVEL,
    ACLASSE_TIPO_VEIC_CAMINHAO,
    ACLASSE_TIPO_VEIC_CAVALOMECANICO,
    ACLASSE_TIPO_VEIC_EMPILHADEIRA,
    ACLASSE_TIPO_VEIC_MAQUINA,
    ACLASSE_TIPO_VEIC_MOTOCICLETA,
    ACLASSE_TIPO_VEIC_NENHUM,
    ACLASSE_TIPO_VEIC_ONIBUS,
    ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE,
    ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO,
    ACLASSE_TIPO_VEIC_UTILITARIO,
    ANAO,
    ASIM
} from '../../../consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { CloudUploadOutlined as CloudUploadOutlinedIcon } from '@material-ui/icons';
import { appendFieldsToFormData, getCodUsuarioRegistrou, validateField } from 'lib/functions';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

class TipoVeiculoForm extends Component {
    state = {
        tipoveiculo: {
            codtipoveiculo: '',
            desctipoveiculo: '',
            capacidadepax: '',
            obs: '',
            classe: 0,
            inativo: ANAO
        },
        imagemPreview: '',
        imagemNome: '',
        imagemFile: null,
        isDragOver: false,
        removeFoto: false,
        isLoadingTipoVeiculo: true,
        openAlert: false,
        messageAlert: '',
        isImageModalOpen: false,
        isNewRecord: false,
        isView: false,
        openRemoveImageModal: false,
        errors: {},
        schema: {
            desctipoveiculo: {
                presence: { allowEmpty: false, message: 'Descrição do tipo obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            },
            capacidadepax: {
                presence: { allowEmpty: false, message: 'Capacidade pax obrigatória' },
                length: { maximum: 64 },
                type: 'integer'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        try {
            if (!isNaN(Number(id))) {
                await this.loadTiposVeiculo(id, location.pathname.includes('/view'));
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    isLoadingTipoVeiculo: false,
                    removeFoto: false,
                    tipoveiculo: this.getTipoVeiculoDefault()
                });
            }
        } catch (error) {
            console.error('Erro ao carregar tipo de veículo:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar tipo de veículo!'
            );

            this.setState({ isLoadingTipoVeiculo: false });
        }
    };

    /* Retorna o tipo de veículo padrão */
    getTipoVeiculoDefault = () => ({
        codtipoveiculo: '',
        desctipoveiculo: '',
        capacidadepax: '',
        obs: '',
        classe: ACLASSE_TIPO_VEIC_NENHUM,
        inativo: ANAO
    });

    /* Carrega os tipos de veículo */
    loadTiposVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/tipoveiculo/${id}`);
        const registro = response?.data?.data?.[0];

        if (!registro) {
            this.handleOpenAlert('Tipo de veículo não encontrado!');

            history.push('/frotas/tipoveiculo');

            return;
        }

        this.setState({
            tipoveiculo: {
                ...registro,
                obs: registro.obs || '',
                classe: registro.classe ?? ACLASSE_TIPO_VEIC_NENHUM,
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView,
            isLoadingTipoVeiculo: false,
            removeFoto: false,
            imagemPreview: registro.foto || '',
            imagemNome: ''
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        if (name === 'obs') {
            this.setState(prev => ({
                tipoveiculo: {
                    ...prev.tipoveiculo,
                    [name]: value
                }
            }));
            return;
        }

        let adjustedValue;

        if (type === 'checkbox') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (name === 'classe') {
            adjustedValue = Number(value);
        } else if (name === 'capacidadepax') {
            adjustedValue = value.replace(/\D/g, '');
        } else {
            adjustedValue = typeof value === 'string' ? value.toUpperCase() : value;
        }

        this.setState(prev => ({
            tipoveiculo: {
                ...prev.tipoveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de tipo de veículo */
    getPayloadTipoVeiculo = () => {
        const { imagemFile, removeFoto, tipoveiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (!codusuarioregistrou) {
            throw new Error('Código do usuário não encontrado!');
        }

        const fields = {
            desctipoveiculo: tipoveiculo.desctipoveiculo || '',
            capacidadepax: tipoveiculo.capacidadepax || '',
            classe: tipoveiculo.classe !== undefined ? tipoveiculo.classe : ACLASSE_TIPO_VEIC_NENHUM,
            obs: tipoveiculo.obs || '',
            inativo: tipoveiculo.inativo || ANAO,
            codusuarioregistrou,
            removefoto: removeFoto ? ASIM : ANAO
        };

        const formData = appendFieldsToFormData(fields);

        if (imagemFile) {
            formData.append('foto', imagemFile);
        }

        return formData;
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { isNewRecord, tipoveiculo } = this.state;
        const { history, loadTiposVeiculo } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const formData = this.getPayloadTipoVeiculo();

            if (isNewRecord) {
                await api.post('/tipoveiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.put(`/tipoveiculo/${tipoveiculo.codtipoveiculo}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            if (loadTiposVeiculo) loadTiposVeiculo();

            history.push(this.getBaseRoute());
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(this.getBaseRoute());
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema, tipoveiculo } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'desctipoveiculo',
            'capacidadepax'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, tipoveiculo[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Processa o arquivo selecionado ou arrastado */
    handleSelectedFile = (file, callback) => {
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagemPreview: reader.result,
                imagemFile: file,
                imagemNome: file.name,
                removeFoto: false,
                isDragOver: false
            }, () => {
                if (callback) callback();
            });
        };

        reader.readAsDataURL(file);
    };

    /* Upload via input */
    handleImageChange = (event) => {
        const input = event.target;
        const file = input.files[0];

        this.handleSelectedFile(file, () => {
            input.value = '';
        });
    };

    /* Drag and drop */
    handleDragEnter = (event) => {
        const { isView } = this.state;

        event.preventDefault();
        event.stopPropagation();

        if (!isView) {
            this.setState({ isDragOver: true });
        }
    };

    /* Arrastar o arquivo */
    handleDragOver = (event) => {
        const { isDragOver, isView } = this.state;

        event.preventDefault();
        event.stopPropagation();

        if (!isView && !isDragOver) {
            this.setState({ isDragOver: true });
        }
    };

    /* Arrastar e sair */
    handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!event.currentTarget.contains(event.relatedTarget)) {
            this.setState({ isDragOver: false });
        }
    };

    /* Soltar o arquivo */
    handleDrop = (event) => {
        const { isView } = this.state;

        event.preventDefault();
        event.stopPropagation();

        if (isView) {
            this.setState({ isDragOver: false });

            return;
        }

        const file = event.dataTransfer?.files?.[0];

        this.handleSelectedFile(file);
    };

    /* Apaga a imagem */
    handleRemoveImage = () => {
        this.setState(prev => ({
            imagemPreview: '',
            imagemFile: null,
            imagemNome: '',
            removeFoto: true,
            tipoveiculo: {
                ...prev.tipoveiculo,
                foto: ''
            }
        }));
    };

    /* Abre o modal */
    handleOpenImageModal = () => {
        this.setState({ isImageModalOpen: true });
    };

    /* Fecha o modal */
    handleCloseImageModal = () => {
        this.setState({ isImageModalOpen: false });
    };

    /* Abre a confirmação para a remoção da imagem */
    handleOpenRemoveImageModal = () => {
        this.setState({ openRemoveImageModal: true });
    };

    /* Fecha a confirmação para a remoção da imagem */
    handleCloseRemoveImageModal = () => {
        this.setState({ openRemoveImageModal: false });
    };

    /* Confirma a remoção da imagem */
    confirmRemoveImage = () => {
        this.setState({ openRemoveImageModal: false }, () => {
            this.handleRemoveImage();
        });
    };

    /* Pega a rota base - recurso compartilhado entre módulos */
    getBaseRoute = () => {
        const { location } = this.props;
        const pathname = location?.pathname || '';

        if (pathname.startsWith('/front/')) {
            return '/front/tipoveiculo';
        }

        return '/frotas/tipoveiculo';
    };

    render() {
        const {
            errors,
            imagemNome,
            imagemPreview,
            isDragOver,
            isImageModalOpen,
            isLoadingTipoVeiculo,
            isView,
            messageAlert,
            openAlert,
            openRemoveImageModal,
            tipoveiculo
        } = this.state;

        const hasImage = !!imagemPreview;
        const insertButtonLabel = hasImage ? 'Inserir Outro Arquivo' : 'Inserir Arquivo';
        const borderColor = isDragOver ? '#1976d2' : hasImage ? '#66bb6a' : '#bdbdbd';
        const backgroundColor = isDragOver ? '#e3f2fd' : hasImage ? '#edf7ed' : '#f5f5f5';
        const infoTextColor = hasImage ? '#2e7d32' : '#616161';

        if (isLoadingTipoVeiculo) {
            return (
                <CardContent>
                    <Typography variant="body1">Carregando tipo de veículo...</Typography>
                </CardContent>
            );
        }

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Tipo de veículo {tipoveiculo.codtipoveiculo || ''}
                        </Typography>

                        <FormControlLabel
                            label={(tipoveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(tipoveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            marginTop: 10,
                            gap: 12
                        }}
                    >
                        <TextField
                            label="Descrição"
                            name="desctipoveiculo"
                            value={tipoveiculo.desctipoveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.desctipoveiculo || ''}
                            error={!!errors.desctipoveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                flex: '0 1 300px',
                                minWidth: 300
                            }}
                        />

                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                flex: '0 1 280px',
                                minWidth: 240
                            }}
                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Classe de Veículo
                            </InputLabel>

                            <Select
                                label="Classe de Veículo"
                                native
                                onChange={this.onChange}
                                value={String(tipoveiculo.classe ?? ACLASSE_TIPO_VEIC_NENHUM)}
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'classe'
                                }}
                            >
                                <option
                                    key={ACLASSE_TIPO_VEIC_NENHUM}
                                    value={ACLASSE_TIPO_VEIC_NENHUM}
                                >
                                    {"Nenhum"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAMINHAO}
                                    value={ACLASSE_TIPO_VEIC_CAMINHAO}
                                >
                                    {"Caminhão"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                    value={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                >
                                    {"Automóvel"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_UTILITARIO}
                                    value={ACLASSE_TIPO_VEIC_UTILITARIO}
                                >
                                    {"Utilitário"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_ONIBUS}
                                    value={ACLASSE_TIPO_VEIC_ONIBUS}
                                >
                                    {"Ônibus"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                    value={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                >
                                    {"Reboque/semirreboque"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                    value={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                >
                                    {"Empilhadeira"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                    value={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                >
                                    {"Motocicleta"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MAQUINA}
                                    value={ACLASSE_TIPO_VEIC_MAQUINA}
                                >
                                    {"Máquina"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                    value={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                >
                                    {"Superdimensionado"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                    value={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                >
                                    {"Cavalo mecânico"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_AQUATICO}
                                    value={ACLASSE_TIPO_VEIC_AQUATICO}
                                >
                                    {"Aquático"}
                                </option>
                            </Select>
                        </FormControl>

                        <TextField
                            label="Capacidade pax"
                            name="capacidadepax"
                            value={tipoveiculo.capacidadepax || ''}
                            variant="outlined"
                            disabled={isView}
                            type="number"
                            error={!!errors.capacidadepax}
                            helperText={errors.capacidadepax || ''}
                            inputProps={{ min: 1 }}
                            style={{
                                flex: '0 1 220px',
                                minWidth: 220
                            }}
                            onChange={this.onChange}
                        />
                    </Box>

                    <br />

                    <Typography
                        color="textSecondary"
                        component="p"
                        variant="body2"
                    >
                        Observação
                    </Typography>

                    <FormGroup>
                        <textarea
                            id="obs"
                            name="obs"
                            onChange={this.onChange}
                            value={tipoveiculo.obs || ''}
                            disabled={isView}
                            style={{
                                width: '100%',
                                minHeight: '100px',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                fontFamily: 'Calibri, sans-serif',
                                boxSizing: 'border-box'
                            }}
                        />
                    </FormGroup>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="flex-start"
                        style={{
                            gap: 16,
                            marginTop: 16
                        }}
                    >
                        <Box style={{ width: '100%' }}>
                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Imagem
                            </Typography>

                            <Box
                                onDragEnter={this.handleDragEnter}
                                onDragOver={this.handleDragOver}
                                onDragLeave={this.handleDragLeave}
                                onDrop={this.handleDrop}
                                style={{
                                    width: '100%',
                                    minHeight: 260,
                                    border: `2px dashed ${borderColor}`,
                                    borderRadius: 12,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: backgroundColor,
                                    marginTop: 8,
                                    padding: '24px 20px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <CloudUploadOutlinedIcon
                                    style={{
                                        fontSize: 42,
                                        color: hasImage ? '#43a047' : '#90a4ae',
                                        marginBottom: 12
                                    }}
                                />

                                <Typography
                                    variant="body1"
                                    style={{
                                        color: '#424242',
                                        textAlign: 'center',
                                        marginBottom: 6
                                    }}
                                >
                                    {hasImage
                                        ? 'Arquivo selecionado'
                                        : 'Arraste um arquivo aqui ou selecione um no botão abaixo'
                                    }
                                </Typography>

                                {imagemNome ? (
                                    <Typography
                                        variant="caption"
                                        style={{
                                            display: 'block',
                                            marginBottom: 16,
                                            color: infoTextColor,
                                            textAlign: 'center',
                                            wordBreak: 'break-word'
                                        }}
                                    >
                                        Arquivo: {imagemNome}
                                    </Typography>
                                ) : null}

                                <Button
                                    component="label"
                                    variant="contained"
                                    color={!hasImage ? 'primary' : undefined}
                                    disabled={isView}
                                    style={{
                                        textTransform: 'none',
                                        minWidth: 190,
                                        ...(hasImage && {
                                            backgroundColor: '#43a047',
                                            color: '#fff'
                                        })
                                    }}
                                >
                                    {insertButtonLabel}

                                    <input
                                        accept="*/*"
                                        style={{ display: 'none' }}
                                        id="upload-imagem-tipo-veiculo"
                                        type="file"
                                        onChange={this.handleImageChange}
                                    />
                                </Button>
                            </Box>

                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                style={{
                                    marginTop: 10,
                                    gap: 10,
                                    width: '100%'
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={this.handleOpenRemoveImageModal}
                                    disabled={!imagemPreview || isView}
                                    style={{ textTransform: 'none' }}
                                >
                                    Remover
                                </Button>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.handleOpenImageModal}
                                    disabled={!imagemPreview}
                                    style={{ textTransform: 'none' }}
                                >
                                    Visualizar
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>

                    <AlertInformation
                        open={openAlert}
                        message={messageAlert}
                        handleClose={this.handleCloseAlert}
                    />

                    <DeleteConfirmationModal
                        open={openRemoveImageModal}
                        handleClose={this.handleCloseRemoveImageModal}
                        itemId=""
                        message="Confirma remoção do arquivo de imagem inserido?"
                        handleDelete={this.confirmRemoveImage}
                    />

                    <Modal
                        open={isImageModalOpen}
                        onClose={this.handleCloseImageModal}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{ timeout: 500 }}
                    >
                        <Fade in={isImageModalOpen}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '90vw',
                                    height: '85vh',
                                    maxWidth: 1040,
                                    maxHeight: 585,
                                    backgroundColor: 'transparent',
                                    borderRadius: 12,
                                    boxShadow: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 0
                                }}
                            >
                                <img
                                    src={imagemPreview}
                                    alt="Imagem expandida"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        borderRadius: '8px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                        </Fade>
                    </Modal>
                </CardContent>
            </div>
        );
    }
};

export default TipoVeiculoForm;